/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/details/customFieldsDetails"/>
import * as React from 'react';
import { IDocumentImportInformation } from "../interfaces";
import { ContentDivider, FixedGridLayout, LockedField } from "@medius/ui-controls";
import { getFlagValue, isCustomFieldBooleanField1NotEmpty, isCustomFieldBooleanField2NotEmpty, isCustomFieldBooleanField3NotEmpty, isCustomFieldBooleanField4NotEmpty, isCustomFieldBooleanField5NotEmpty, isCustomFieldDateTimeField1NotEmpty, isCustomFieldDateTimeField2NotEmpty, isCustomFieldDateTimeField3NotEmpty, isCustomFieldDateTimeField4NotEmpty, isCustomFieldDateTimeField5NotEmpty, isCustomFieldNumericField1NotEmpty, isCustomFieldNumericField2NotEmpty, isCustomFieldNumericField3NotEmpty, isCustomFieldNumericField4NotEmpty, isCustomFieldNumericField5NotEmpty, isCustomFieldTextField1NotEmpty, isCustomFieldTextField2NotEmpty, isCustomFieldTextField3NotEmpty, isCustomFieldTextField4NotEmpty, isCustomFieldTextField5NotEmpty } from "./common";
import { localizeDate } from '../../prepaymentInvoices/appliedPrepaymentsCommon';

interface CustomfieldsDetailsProps {
    information: IDocumentImportInformation;
}

export const CustomfieldsDetails = (props: CustomfieldsDetailsProps) => {
    return (
        <>
            <ContentDivider />
            <FixedGridLayout columns={4}>
                {isCustomFieldTextField1NotEmpty(props.information) && (
                    <LockedField
                        fieldLabel={props.information?.textCustomField1Name}
                        valueText={props.information?.customFieldTextCustomField1}
                    />
                )}
                {isCustomFieldNumericField1NotEmpty(props.information) && (
                    <LockedField
                        fieldLabel={props.information?.numericCustomField1Name}
                        valueText={
                            props.information?.customFieldNumericCustomField1 &&
                            props.information?.customFieldNumericCustomField1.toString()
                        }
                    />
                )}
                {isCustomFieldBooleanField1NotEmpty(props.information) && (
                    <LockedField
                        fieldLabel={props.information?.booleanCustomField1Name}
                        valueText={getFlagValue(props.information?.customFieldBooleanCustomField1)}
                    />
                )}
                {isCustomFieldDateTimeField1NotEmpty(props.information) && (
                    <LockedField
                        fieldLabel={props.information?.dateTimeCustomField1Name}
                        valueText={
                            props.information?.customFieldDateTimeCustomField1 &&
                            localizeDate(new Date(props.information?.customFieldDateTimeCustomField1))
                        }
                    />
                )}

                {/* Custom Field 2 */}
                {isCustomFieldTextField2NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.textCustomField2Name}
                        valueText={props.information?.customFieldTextCustomField2}
                    />
                )}
                {isCustomFieldNumericField2NotEmpty({ ...props.information}) && (
                    <LockedField
                        fieldLabel={props.information?.numericCustomField2Name}
                        valueText={
                            props.information?.customFieldNumericCustomField2 &&
                            props.information?.customFieldNumericCustomField2.toString()
                        }
                    />
                )}
                {isCustomFieldBooleanField2NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.booleanCustomField2Name}
                        valueText={getFlagValue(props.information?.customFieldBooleanCustomField2)}
                    />
                )}
                {isCustomFieldDateTimeField2NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.dateTimeCustomField2Name}
                        valueText={
                            props.information?.customFieldDateTimeCustomField2 &&
                            localizeDate(new Date(props.information?.customFieldDateTimeCustomField2))
                        }
                    />
                )}

                {/* Custom Field 3 */}
                {isCustomFieldTextField3NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.textCustomField3Name}
                        valueText={props.information?.customFieldTextCustomField3}
                    />
                )}
                {isCustomFieldNumericField3NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.numericCustomField3Name}
                        valueText={
                            props.information?.customFieldNumericCustomField3 &&
                            props.information?.customFieldNumericCustomField3.toString()
                        }
                    />
                )}
                {isCustomFieldBooleanField3NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.booleanCustomField3Name}
                        valueText={getFlagValue(props.information?.customFieldBooleanCustomField3)}
                    />
                )}
                {isCustomFieldDateTimeField3NotEmpty({ ...props.information}) && (
                    <LockedField
                        fieldLabel={props.information?.dateTimeCustomField3Name}
                        valueText={
                            props.information?.customFieldDateTimeCustomField3 &&
                            localizeDate(new Date(props.information?.customFieldDateTimeCustomField3))
                        }
                    />
                )}

                {/* Custom Field 4 */}
                {isCustomFieldTextField4NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.textCustomField4Name}
                        valueText={props.information?.customFieldTextCustomField4}
                    />
                )}
                {isCustomFieldNumericField4NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.numericCustomField4Name}
                        valueText={
                            props.information?.customFieldNumericCustomField4 &&
                            props.information?.customFieldNumericCustomField4.toString()
                        }
                    />
                )}
                {isCustomFieldBooleanField4NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.booleanCustomField4Name}
                        valueText={getFlagValue(props.information?.customFieldBooleanCustomField4)}
                    />
                )}
                {isCustomFieldDateTimeField4NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.dateTimeCustomField4Name}
                        valueText={
                            props.information?.customFieldDateTimeCustomField4 &&
                            localizeDate(new Date(props.information?.customFieldDateTimeCustomField4))
                        }
                    />
                )}

                {/* Custom Field 5 */}
                {isCustomFieldTextField5NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.textCustomField5Name}
                        valueText={props.information?.customFieldTextCustomField5}
                    />
                )}
                {isCustomFieldNumericField5NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.numericCustomField5Name}
                        valueText={
                            props.information?.customFieldNumericCustomField5 &&
                            props.information?.customFieldNumericCustomField5.toString()
                        }
                    />
                )}
                {isCustomFieldBooleanField5NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.booleanCustomField5Name}
                        valueText={getFlagValue(props.information?.customFieldBooleanCustomField5)}
                    />
                )}
                {isCustomFieldDateTimeField5NotEmpty({ ...props.information }) && (
                    <LockedField
                        fieldLabel={props.information?.dateTimeCustomField5Name}
                        valueText={
                            props.information?.customFieldDateTimeCustomField5 &&
                            localizeDate(new Date(props.information?.customFieldDateTimeCustomField5))
                        }
                    />
                )}
            </FixedGridLayout>
        </>
    );
};